import { gql, useMutation } from '@apollo/client'
import * as React from 'react'
import { Link, useHistory } from 'react-router-dom'

import { ProgressIndicator } from '../../components/authentication/progress-indicator'
import { VerificationCodeForm } from '../../components/authentication/verification-code-form'
import { Paths } from '../../config/routes'
import { useUser } from '../../contexts/user/user-context'
import { SignInForm } from './sign-in-form'

const fetchTransactionsBalances = gql`
    mutation fetchingTranasctionBalances {
        fetchTranasctionsBalances
    }
`

export function SignInFlow() {
    const { user, setUser, clearUser } = useUser()
    const [fetchBalances] = useMutation(fetchTransactionsBalances)
    const history = useHistory()

    return (
        <div className='pt-6 md:pt-12'>
            {!user ? (
                // Render a custom heading for this flow if your on the first step (IE no user in state)
                <header>
                    <p className='mb-12 text-lg lg:text-right text-gray'>
                        Don't have an account?{' '}
                        <Link to={Paths.SIGN_UP} className='text-black'>
                            Sign up
                        </Link>
                    </p>
                </header>
            ) : (
                <ProgressIndicator
                    step={user ? 2 : 1}
                    total={2}
                    stepText={['Sign in', 'Enter 2FA 6-digit code']}
                    onBack={() => clearUser()}
                />
            )}
            <div className='max-w-lg'>
                {!user ? (
                    <SignInForm
                        onComplete={user => {
                            setUser(user)
                        }}
                    />
                ) : (
                    <VerificationCodeForm
                        user={user}
                        onComplete={authenticatedUser => {
                            setUser(authenticatedUser)
                            setTimeout(() => fetchBalances(), 1000)
                            history.push(Paths.ONBOARDING)
                        }}
                    />
                )}
            </div>
        </div>
    )
}
